import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';

@Component({
  selector: 'edge-fitness',
  templateUrl: './fitness.component.html',
  styleUrls: ['./fitness.component.scss']
})
export class PageFitnessComponent {
  tagline = '<span>GoArmy Edge Fitness.</span> Visualize. Learn. Compete.';
  socialIcons = [
    {
      link: 'https://twitter.com/goarmyedge',
      image: '/assets/images/social/logo-white.png',
      alt: 'Twitter',
      sport: 'Football'
    },
    {
      link: 'https://www.youtube.com/goarmyedge',
      image: '/assets/images/social/youtube.svg',
      alt: 'YouTube',
      sport: 'Football'
    },
    {
      link: 'https://www.facebook.com/GoArmyEdgeFootball/',
      image: '/assets/images/social/facebook.svg',
      alt: 'Facebook',
      sport: 'Football'
    }
  ];

  constructor(private store: Store<fromRoot.State>) {}
}
